/**************************************************
 * Nombre:       Formulario_Evento
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {CalendarMonth, Flag, TitleOutlined, Warning} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";
import {ESTADOSEVENTO} from "../../Constantes";
import IngresoFecha from "../../Modulo_formularios/Componentes/IngresoFecha";

const Formulario_Capacitacion = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Typography>Imagen 2x3 (maximo 300kb)</Typography>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoImagenCrop dato={'img'} {...props} ancho={2} alto={3}/>
                </Grid>

                <Grid container size={6}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'} dato={'estado'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={ESTADOSEVENTO.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelect Icono={Warning} nombre={'Obligatoria'} dato={'obigatoria'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={['Si', 'No']}
                    />
                </Grid>



                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Nombre'} dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={5} nombre={'Descripcion'} dato={'descripcion'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Titulo Obtenido'} dato={'titulo'} {...props}
                                  requerido={'El Titulo es requerido'}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Capacitacion